jQuery(document).ready(function(){

  // Temp fix for redirection when changing page of filtered result, mob version
 
  // Mobile menu next buttons

  jQuery("nav.mobile-menu-open li.menu-item-has-children").prepend("<button class='open-next'><i class='fa fa-angle-right'></i></button>");

  // Toggle mobile sub menus
  jQuery("button.open-next").on("click", function() {
    jQuery(this).closest("li").find(" > ul.sub-menu").slideToggle();
  });

  jQuery("nav.mobile-menu-open li.menu-item-has-children li > a").on("click", function() {
    jQuery(this).closest("li").find(" > ul.sub-menu").slideToggle();
  });

  jQuery("#open-mobile").on("click", function() {
    jQuery("nav.mobile-menu-open").slideToggle();
  });

    jQuery(".specs h3").click(function(){
      jQuery(this).closest("div").find(".specs-show").slideToggle();
      
  });

  jQuery("a#open-search").click(function(){
      jQuery("#search-bar").fadeToggle(200);
      jQuery('nav.main-menu').fadeToggle(100);
  });

  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() > 200) {
      jQuery("header.main").addClass("scrolled");
    }
  });

  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() < 200) {
      jQuery("header.main").removeClass("scrolled");
    }
  });

  jQuery("h3.documents").click(function(){
    jQuery("#documents-content").slideDown();
    jQuery("#technical-content").hide();
    jQuery('#packing-content').hide();
  });

  jQuery("h3.technical").click(function(){
    jQuery("#technical-content").slideDown();
    jQuery("#documents-content").hide();
    jQuery('#packing-content').hide();
  });

  jQuery("h3.packing").click(function(){
    jQuery("#packing-content").slideDown();
    jQuery("#technical-content").hide();
    jQuery('#documents-content').hide();
  });

 
  jQuery('.single-product .woocommerce-product-gallery__wrapper a').attr('data-featherlight', 'image');
});
